import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useResourcesContext, useEmpresa } from "app/contexts";

export function ActividadesEconomicasTable() {
  const { getActividadEconomica } = useResourcesContext();
  const { empresa, deleteActividad } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Actividades económicas (requerido)</strong>
            </h5>

            <AddLink
              to="actividades-economicas/add"
              title="Agregar actividad económica"
            />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.actividades_economicas.length ? (
            <Table titles={["#", "Tipo", "Actividad Económica", "Opciones"]}>
              {empresa.actividades_economicas.map((actividad, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {actividad.actividad_economica_principal
                      ? "Principal"
                      : "Secundaria"}
                  </td>

                  <td>
                    <div>
                      {getActividadEconomica(actividad.actividad_economica_id)
                        ?.actividad_economica_descripcion || "Cargando..."}

                      <br />

                      <b>Detalles: </b>
                      {actividad.actividad_economica_detalles}
                    </div>
                  </td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`actividades-economicas/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteActividad(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos una actividad económica
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
